// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__2o_0R","bold":"Icon_bold__ttuOt","size16":"Icon_size16__-wGgn","size24":"Icon_size24__1ZOcK","size32":"Icon_size32__rTkAD"};